import { KnownDeliveryDtoDeliveryType } from '@groundfloor-platform/mgmt-service-g-sdk';
import {
  mapProjectModuleToExternalDeliveryType,
  mapProjectModuleToInternalDeliveryType
} from '../../../project-modules/mappings';

export interface EffectiveModules {
  internal: string[];
  external: string[];
}

/**
 * Convert effective module arrays to the flat list of delivery transaction types they represent.
 */
export function effectiveModulesToDeliveryTypes(effective: EffectiveModules): KnownDeliveryDtoDeliveryType[] {
  // If the type does not map, it will not be added
  const types: KnownDeliveryDtoDeliveryType[] = [];
  effective.external.forEach((name) => {
    const type = mapProjectModuleToExternalDeliveryType(name);
    if (type) types.push(type);
  });
  effective.internal.forEach((name) => {
    const type = mapProjectModuleToInternalDeliveryType(name);
    if (type) types.push(type);
  });
  return types;
}
